<template>
	<sg-modal v-model="isOpen" :title="title" class="image-viewer-modal">
		<div class="flex h-full w-full items-center justify-center bg-black">
			<img
				:src="imageSrc"
				:alt="title"
				class="h-full w-full object-contain"
			/>
		</div>
	</sg-modal>
</template>

<script setup lang="ts">
	import SgModal from "@/components/ui/modals/SgModal.vue";

	defineProps<{
		imageSrc: string;
		title?: string;
	}>();

	const isOpen = defineModel<boolean>({ default: false });
</script>

<style scoped>
	/* Desktop styles - make it full screen */
	@media (min-width: 768px) {
		.image-viewer-modal {
			--height: 100%;
			--width: 100%;
		}
	}
</style>
